import Quill, { type Parchment } from 'quill'

const ImageBlot = Quill.import('formats/image') as typeof Parchment.EmbedBlot

export class CustomImage extends ImageBlot {
  blotName = 'image'
  tagName = 'IMG'

  static create(src: string) {
    const node = super.create(src)
    return node
  }

  static formats(domNode: HTMLElement): Record<string, string | null> {
    return {
      'data-id': domNode.getAttribute('data-id'),
      width: domNode.getAttribute('width'),
      height: domNode.getAttribute('height'),
    }
  }

  format(name: string, value: string | null) {
    const domNode = this.domNode as HTMLElement

    // Image id
    if (name === 'data-id') {
      if (value) domNode.setAttribute('data-id', value)
      else domNode.removeAttribute('data-id')
    }

    // Width and Height
    else if (name === 'width' || name === 'height') {
      if (value) domNode.setAttribute(name, value)
      else domNode.removeAttribute(name)
    }

    // Fallback
    else {
      super.format(name, value)
    }
  }
}
